<template>
  <div class="page-asset">
    <!-- 搜索框 -->
    <van-search v-model="searchValue" placeholder="请输入标题搜索" />

    <!-- 列表区域 -->
    <div class="list-wrapper">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :disabled="containerScrollTop > 0"
        style="height: 100%">
        <div ref="vListContainer" class="virtual-list" @scroll="onScroll">
          <div class="virtual-list-phantom" :style="{ height: totalHeight + 'px' }"></div>
          <div class="virtual-list-content" :style="{ transform: 'translateY(' + translateY + 'px)' }">
            <van-cell v-for="item in visibleList" :key="item.id || item.name" :title="item.name"
              @click="handleList(item)" />
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>

export default {
  name: "receiveScan",
  components: {},
  data() {
    return {
      list: [],
      searchValue: '',
      loading: false,
      finished: false,
      refreshing: false,

      // Virtual Scroll Config
      itemHeight: 44, // Estimate for van-cell
      containerHeight: 0,
      containerScrollTop: 0,
      startIndex: 0,
      endIndex: 0,
      overscan: 5,

      // Legacy data properties inferred from usage
      focusModel: '',
      packageCode: '',
      orderCode: '',
      packCodeList: [],
      receiptOrderID: '',
      lastShow: '',
      show: false,
      showEdit: false,
    };
  },
  computed: {
    filteredList() {
      if (!this.searchValue) {
        return this.list;
      }
      const lowerKey = this.searchValue.toLowerCase();
      return this.list.filter(item =>
        item.name && item.name.toLowerCase().includes(lowerKey)
      );
    },
    visibleList() {
      return this.filteredList.slice(this.startIndex, this.endIndex);
    },
    totalHeight() {
      return this.filteredList.length * this.itemHeight;
    },
    translateY() {
      return this.startIndex * this.itemHeight;
    }
  },
  created() {
    this.getScanCode();
    this.initload();
  },
  mounted() {
    this.$nextTick(() => {
      this.updateContainer();
      window.addEventListener('resize', this.updateContainer);
    });
  },
  unmounted() {
    window.removeEventListener('resize', this.updateContainer);
  },
  watch: {
    searchValue() {
      // Reset scroll position when search changes
      if (this.$refs.vListContainer) {
        this.$refs.vListContainer.scrollTop = 0;
      }
      this.updateRange(0);
    },
    list() {
      // Update range when list data updates
      this.$nextTick(() => {
        if (this.containerHeight === 0) {
          this.updateContainer();
        } else {
          const scrollTop = this.$refs.vListContainer ? this.$refs.vListContainer.scrollTop : 0;
          this.updateRange(scrollTop);
        }
      });
    }
  },
  methods: {
    onRefresh() {
      if (this.containerScrollTop > 0) {
        this.refreshing = false;
        return;
      }
      this.initload();
    },
    handleList(item) {

      this.$router.push({
        path: "receiveCheck",
        query: {
          id: item.id,
          name: item.name,
          code: item.code,
        },
      });
    },
    // 列表刷新
    initload() {
      let that = this;
      that.refreshing = true;
      var option1 = {
        portName: "cms.Check.getZlList",
        successCallback: function (data) {
          that.list = data.entities || [];
          that.refreshing = false;
        },
      };
      this.$sapi.callPort(option1);
    },

    // Virtual Scroll Methods
    onScroll(e) {
      const scrollTop = e.target.scrollTop || 0;
      this.containerScrollTop = scrollTop;
      this.updateRange(scrollTop);
    },
    updateContainer() {
      if (this.$refs.vListContainer) {
        this.containerHeight = this.$refs.vListContainer.clientHeight;
        this.containerScrollTop = this.$refs.vListContainer.scrollTop || 0;
        this.updateRange(this.$refs.vListContainer.scrollTop);
      } else {
        this.containerHeight = window.innerHeight - 100;
        this.containerScrollTop = 0;
        this.updateRange(0);
      }
    },
    updateRange(scrollTop) {
      const count = this.filteredList.length;
      const visibleCount = Math.ceil(this.containerHeight / this.itemHeight);

      let start = Math.floor(scrollTop / this.itemHeight) - this.overscan;
      if (start < 0) start = 0;

      let end = start + visibleCount + (this.overscan * 2);
      if (end > count) end = count;

      this.startIndex = start;
      this.endIndex = end;
    },

    onfocus(value) {
      this.focusModel = "diffPackCode";
    },
    onclick(value) {
      this.show = true;
      this.lastShow = "diffPackCode";
    },
    onRead(text) {
      var me = this;
      if (this.lastShow === "packageCode") {
        me.packageCode = text;
        var option = {
          portName: "fr.order.ReceiptOrderLevel.editStatus",
          data: { packageCode: me.packageCode, orderCode: me.orderCode },
          needLoading: false,
          successCallback: function (data) {
            me.packCodeList.push(text);
          },
        };
        this.$sapi.callPort(option);
      } else if (this.lastShow === "diffPackCode") {
        me.$refs.scanWin.packageCode = text;
        var option1 = {
          portName: "fr.order.ReceiptOrderLevel.editStatus",
          data: { packageCode: text, orderCode: me.orderCode },
          needLoading: false,
          successCallback: function (data) {
            let checkQty = data.data.checkQty;
            me.$refs.scanWin.checkQty = checkQty;
          },
        };
        this.$sapi.callPort(option1);
      }
    },
    getScanCode: function () {
      if (!window.Capacitor) {
        return;
      }
      var me = this;
      Capacitor.Plugins.Scanner.addListener("onScan", (data) => {
        var barcode = data.barcode;
        console.log(data.barcode);
        switch (me.focusModel) {
          case "packageCode":
            me.packageCode = barcode;
            var option = {
              portName: "fr.order.ReceiptOrderLevel.editStatus",
              data: { packageCode: me.packageCode, orderCode: me.orderCode },
              needLoading: false,
              successCallback: function (data) {
                me.packCodeList.push(barcode);
              },
            };
            this.$sapi.callPort(option);
            break;
          case "diffPackCode":
            me.$refs.scanWin.packageCode = barcode;
            var option1 = {
              portName: "fr.order.ReceiptOrderLevel.editStatus",
              data: { packageCode: barcode, orderCode: me.orderCode },
              needLoading: false,
              successCallback: function (data) {
                let checkQty = data.data.checkQty;
                me.$refs.scanWin.checkQty = checkQty;
              },
            };
            this.$sapi.callPort(option1);
            break;
        }
      });
    },
    diffDeal(value) {
      this.showEdit = true;
    },
    scanCheck: function (id, materialID) {
      materialId.push({
        path: "receiveCheck",
        query: { materialId: materialID },
      });
    },
    bindPackCode: function (id, materialID) {
      this.$router.push({
        path: "bindPackageCode",
        query: { materialId: materialID },
      });
    },
    submitReceive(value) {
      var me = this;
      var option = {
        portName: "fr.order.ReceiptOrderLevel.saveReceive",
        data: {
          "receiptOrder.id": me.receiptOrderID,
          packCodeList: me.packCodeList,
        },
        needLoading: true,
        successCallback: function (data) {
          me.$dialog
            .alert({
              title: "",
              message: "提交成功",
            })
            .then(() => {
              me.packCodeList = [];
              me.$refs.grid.$props.requestData["receiptOrder.id"] =
                me.receiptOrderID;
              me.$refs.grid.onRefresh();
            });
        },
      };
      this.$sapi.callPort(option);
    },
    onOrderCodeConfirm(value) {
      this.packCodeList = [];
      this.orderCode = value.code;
      this.receiptOrderID = value.id;
      this.$refs.grid.$props.requestData["receiptOrder.id"] =
        this.receiptOrderID;
      this.$refs.grid.onRefresh();
    },
    confirmEdit(value) {
      value["orderCode"] = this.orderCode;
      var option = {
        portName: "fr.order.ReceiptOrderLevel.diffDeal",
        data: value,
        needLoading: true,
        successCallback: () => {
          this.$dialog
            .alert({
              title: "",
              message: "上报成功",
            })
            .then(() => {
              this.$refs.grid.$props.requestData["receiptOrder.id"] =
                this.receiptOrderID;
              this.$refs.grid.onRefresh();
            });
        },
      };
      this.$sapi.callPort(option);
    },
  },
};
</script>

<style scoped>
.page-asset {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.list-wrapper {
  flex: 1;
  overflow: hidden;
}

.virtual-list {
  height: 100%;
  overflow-y: auto;
  position: relative;
}

.virtual-list-phantom {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: -1;
}

.virtual-list-content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}

.item {
  display: flex;
  border-radius: 5px;
  flex-direction: row;
  box-shadow: 0 0 2px #ddd;
  align-items: center;
  padding: 10px;
  margin: 2px;
}

.item+.item {
  margin-top: 10px;
}

.item>.content {
  flex: 1;
}

.item .time {
  color: #666;
}
</style>
